/** @format */

import t from "../../Actions/ValidationPassagepassActions/types";
const initialState = {
  validationpassagepass_list: {},
  rate_conflicts: {
    success: 1,
    conflict: false,
    conflicts: [],
    message: "",
  },
};

const PassagepassValidationReducer = (state = initialState, action) => {
  switch (action.type) {
    case t.FETCHPASSAGEPASSVALIDATION: {
      return { ...state, validationpassagepass_list: action.payload };
    }
    case t.EDITPASSAGEPASSVALIDATION: {
      return {
        ...state,
        validationpassagepass_list: action.payload,
      };
    }
    case t.CREATEPASSAGEPASSVALIDATION: {
      return {
        ...state,
        validationpassagepass_list: action.payload,
      };
    }
    case t.CHECK_RATE_CONFLICTS: { 
      return { 
        ...state, 
        rate_conflicts: action.payload 
      };
    }
    default:
      return state;
  }
};

export default PassagepassValidationReducer;